import React from 'react';
import './Tooltip.scss';
var Tooltip = function (_a) {
    var text = _a.text, onClick = _a.onClick, children = _a.children, cursor = _a.cursor;
    return (React.createElement("div", { className: "tooltip", onClick: onClick },
        children,
        text ? React.createElement("span", { style: { cursor: cursor ? 'pointer' : 'default', whiteSpace: 'pre-wrap' }, className: "tooltip-text" }, text) : ""));
};
export default Tooltip;
